import { render, staticRenderFns } from "./driverDetailLog.vue?vue&type=template&id=1ff977b5"
import script from "./driverDetailLog.vue?vue&type=script&lang=js"
export * from "./driverDetailLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports